<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left color-theme="white" back-link="返回" :back-link-url="backUrl">
      </f7-nav-left>
      <f7-nav-title>{{ this.$f7route.query.title }}</f7-nav-title>
      <f7-nav-right>
        <f7-link
          @click="editable = !editable"
          v-show="!editable && perms.projectUpdate">
          编辑
        </f7-link>
        <f7-link @click="add" v-show="editable">保存</f7-link>
      </f7-nav-right>
    </f7-navbar>
      <div class="has-content" v-show="!editable">
        <project-view
          :project="project"
          :isBuildingCompany="dictKey === 'majorContractType'">
        </project-view>
      </div>
      <f7-list inline-labels id="addForm" v-show="editable">
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">项目类型</div>
          <input
            slot="input"
            type="text"
            placeholder="请选择"
            id="picker-type"
            readonly
            required
            validate
            data-error-message='必选项'/>
        </f7-list-input>
        <f7-list-input
          label="工程名称"
          type="text"
            :value="project.name"
            @input="project.name = $event.target.value"
            placeholder="请填写"
            required
            validate
            minlength=2
            maxlength=50
            error-message='长度2-50字符'>
          <div slot="media" class="input-required">*</div>
        </f7-list-input>
        <f7-list-input
          label="工程地址"
          type="text"
          :value="project.address"
          @input="project.address = $event.target.value"
          placeholder="请填写或定位"
          required
          validate
          minlength=2
          maxlength=100
          error-message='长度2-100字符'>
          <div slot="media" class="input-required">*</div>
          <f7-link slot="inner-end" icon="cicon-dibiao" @click="callMap"></f7-link>
        </f7-list-input>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">工程规模</div>
          <div slot="input" style="display: flex;">
            <div>
               <input
                :value="project.projectSize"
                @input="project.projectSize = $event.target.value"
                type="number"
                placeholder="请填写"
                required
                validate
                min=0.00
                max=100000000.00
                step="0.01"
                data-error-message='支持两位小数'/>
            </div>
            <input
              type="text"
              placeholder="请选择"
              id="picker-sizeUnit"
              readonly
              required
              validate
              data-error-message='必选项'
              style="max-width: 4rem;"/>
          </div>
        </f7-list-input>
        <f7-list-input
            label="建设单位"
            type="text"
            :value="project.buildDepartment"
            @input="project.buildDepartment = $event.target.value"
            placeholder="请填写"
            validate
            minlength=2
            maxlength=50
            error-message='长度2-50字符'>
          <div slot="media" class="input-required">&nbsp;</div>
        </f7-list-input>
        <f7-list-input
          label="总包单位"
          type="text"
          :value="project.totalDepartment"
          @input="project.totalDepartment = $event.target.value"
          placeholder="请填写"
          required
          validate
          minlength=2
          maxlength=50
          error-message='长度2-50字符'>
          <div slot="media" class="input-required">*</div>
        </f7-list-input>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">承(分)包单位</div>
          <input
            slot="input"
            type="text"
            placeholder="请选择"
            id="picker-companyId"
            readonly
            required
            validate/>
        </f7-list-input>
        <f7-list-item
          title="专业承包类别"
          link=""
          @click="majorContractPopupOpened = true"
          v-show="dictKey === 'majorContractType'">
          <div slot="media" class="input-required">*</div>
          <div slot="after">{{ majorContractDisplay }}</div>
          <f7-popup
            :opened="majorContractPopupOpened"
            @popup:closed="majorContractPopupOpened = false">
            <popup-radio
              title="专业承包类别"
              :data="majorContractTypeList"
              :result.sync="project.majorContractType">
            </popup-radio>
          </f7-popup>
        </f7-list-item>
        <f7-list-item
          link=""
          @click="scopePopupOpened = true"
          v-show="dictKey !== 'majorContractType'">
          <div slot="media" class="input-required">*</div>
          <div slot="inner" class="item-title item-label">
            承(分)包范围
          </div>
          <div class="item-after popup-smart-select">{{ scopeDisplayVal }}</div>
          <f7-popup :opened="scopePopupOpened" @popup:closed="scopePopupOpened = false">
            <scope
              :dictKey="dictKey"
              :opened="scopePopupOpened"
              :result.sync="dutyScopeList">
            </scope>
          </f7-popup>
        </f7-list-item>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">开工日期</div>
          <input
            slot="input"
            type="text"
            placeholder="请选择"
            id="calendar-startTime"
            readonly
            required
            validate/>
        </f7-list-input>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">竣工日期</div>
          <input
            slot="input"
            type="text"
            placeholder="请选择"
            id="calendar-finishTime"
            readonly
            required
            validate/>
        </f7-list-input>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">&nbsp;</div>
          <div slot="label">质量标准</div>
          <input
            slot="input"
            type="text"
            readonly
            placeholder="请选择"
            id="picker-qualityStandard">
        </f7-list-input>
        <f7-list-input
          label="工程说明"
          type="textarea"
          :value="project.remark"
          @input="project.remark = $event.target.value"
          placeholder="请填写"
          validate
          maxlength=500
          error-message='长度0-500字符'
          resizable>
          <div slot="media" class="input-required">&nbsp;</div>
        </f7-list-input>
      </f7-list>
  </f7-page>
</template>
<script>
import Vue from 'vue';
import lodash from 'lodash';
import { toGaodeMap } from '@/util/native';
import { createPicker, createCalendar, createToast } from '@/util/compUtils';
import { getDict } from '@/api/common';
import { getProjectView, addProject, updateProject } from '@/api/project/project';
import { getComanyList } from '@/api/team/worker';
import { Project } from '@/model/reqObject';
import Scope from '@/components/Scope';
import PopupRadio from '@/components/PopupRadio';
import ProjectView from '@/components/ProjectView';

export default {
  props: ['projectId'],
  components: {
    Scope,
    PopupRadio,
    ProjectView,
  },
  data() {
    return {
      editable: lodash.isEmpty(this.projectId),
      projectCategoryList: [],
      projectSizeUnitList: [],
      majorContractTypeList: [],
      qualityStandardList: [],
      project: new Project(),
      dutyScopeList: [],
      scopePopupOpened: false,
      majorContractPopupOpened: false,
      perms: {},
    };
  },
  created() {
    window.setAddress = this.setAddress;
  },
  mounted() {
    const dictKeys = [
      'projectCategory', 'projectSizeUnit', 'qualityStandard', 'majorContractType',
    ];
    Promise.all([
      getDict({ typeCodes: dictKeys }).then((result) => {
        this.projectCategoryList = result.data.projectCategory.codeVoList || [];
        this.projectSizeUnitList = result.data.projectSizeUnit.codeVoList || [];
        this.majorContractTypeList = result.data.majorContractType.codeVoList || [];
        this.qualityStandardList = result.data.qualityStandard.codeVoList || [];
      }),
      getComanyList().then((result) => {
        if (result.code === 0) {
          this.companyList = result.data || [];
        }
      }),
    ]).then(() => this.getInfo());
  },
  computed: {
    backUrl() {
      if (lodash.isEmpty(this.projectId)) {
        return '/';
      }
      return `/project/info/${this.projectId}`;
    },
    scopeDisplayVal() {
      return this.dutyScopeList.join(', ');
    },
    majorContractDisplay() {
      return this.majorContractTypeList
        .filter(item => item.code === this.project.majorContractType)
        .map(item => item.name)
        .join(',');
    },
    dictKey() {
      if (!lodash.isEmpty(this.project.type)
        && !lodash.isEmpty(this.project.companyId)) {
        const company = this.companyList.find(item => item.id === this.project.companyId);
        if (company
          && (
            company.companyType === 'laborCompany'
            || company.companyType === 'specialtyCompany'
            || company.companyType === 'integrateLaborTeam'
            || company.companyType === 'specialtyTeam')) {
          return this.project.type;
        } else if (company && company.companyType === 'buildingCompany') {
          return 'majorContractType';
        }
        return '';
      }
      return '';
    },
  },
  methods: {
    getInfo() {
      if (!lodash.isEmpty(this.projectId)) {
        getProjectView({ projectId: this.projectId }).then((result) => {
          this.project = Object.assign({ pathDisplay: false }, result.data);
          if (!lodash.isEmpty(this.project.dutyScope)) {
            this.dutyScopeList = this.project.dutyScope.split('||');
          }
          this.init();
          this.perms = result.perms || {};
        });
      } else {
        this.init();
      }
    },
    callMap() {
      toGaodeMap(
        this.project.address || '',
        this.project.lat || '',
        this.project.lag || '', 'setAddress');
    },
    setAddress(address, lat, lag) {
      Vue.set(this.project, 'address', address || '');
      Vue.set(this.project, 'lat', lat || '');
      Vue.set(this.project, 'lag', lag || '');
    },
    setErrorMsg(elem) {
      elem.addClass('input-invalid');
      let tmpNode = elem;
      while (this.$$(tmpNode).parent() && this.$$(tmpNode).parent().length !== 0) {
        if (tmpNode.hasClass('item-content')) {
          tmpNode.addClass('item-input-with-error-message');
          tmpNode.addClass('item-input-invalid');
          break;
        } else {
          tmpNode = this.$$(tmpNode).parent();
        }
      }
    },
    add() {
      // this.$f7.input.validateInputs('#addForm');
      if (lodash.isEmpty(this.project.type)) {
        this.setErrorMsg(this.$$('#picker-type'));
      }
      if (lodash.isEmpty(this.project.companyId)) {
        this.setErrorMsg(this.$$('#picker-sizeUnit'));
      }
      if (lodash.isEmpty(this.project.companyId)) {
        this.setErrorMsg(this.$$('#picker-companyId'));
      }
      if (lodash.isEmpty(this.project.planStartupTime)) {
        this.setErrorMsg(this.$$('#calendar-startTime'));
      }
      if (lodash.isEmpty(this.project.planCompletedTime)) {
        this.setErrorMsg(this.$$('#calendar-finishTime'));
      }
      if (!lodash.gte(this.project.planCompletedTime, this.project.planStartupTime)) {
        createToast(this, '竣工日期必须大于等于开工日期');
        return;
      }
      let valided = true;
      this.$$('#addForm').find('input, textarea, select').forEach((inputEl) => {
        valided = valided && !this.$$(inputEl).hasClass('input-invalid');
      });
      if (!valided) {
        return;
      }
      const params = Object.assign(
        this.project,
        { dutyScope: this.dutyScopeList.join('||') },
      );
      const action = lodash.isEmpty(this.projectId) ?
        addProject : updateProject;
      action(params).then((data) => {
        if (data.code === 0) {
          let opt = '添加';
          if (!lodash.isEmpty(this.projectId)) {
            opt = '修改';
          }
          createToast(this, `${opt}任务成功`);
          this.$f7router.back(this.backUrl);
        }
      });
    },
    init() {
      createPicker(
        this,
        '#picker-type',
        this.projectCategoryList.map(d => d.code),
        this.projectCategoryList.map(d => d.name),
        'project',
        'type',
      );
      createPicker(
        this,
        '#picker-sizeUnit',
        this.projectSizeUnitList.map(d => d.code),
        this.projectSizeUnitList.map(d => d.name),
        'project',
        'sizeUnit',
      );
      createPicker(
        this,
        '#picker-companyId',
        this.companyList.map(d => d.id),
        this.companyList.map(d => d.name),
        'project',
        'companyId',
      );
      createCalendar(this, '#calendar-startTime', 'project', 'planStartupTime');
      createCalendar(this, '#calendar-finishTime', 'project', 'planCompletedTime');
      createPicker(
        this,
        '#picker-qualityStandard',
        this.qualityStandardList.map(d => d.code),
        this.qualityStandardList.map(d => d.name),
        'project',
        'qualityStandard',
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .popup-smart-select {
    max-width: 63%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    color: $font-color;
  }

  input.input-invalid::placeholder {
    color: #ff3b30;
  }

  .input-required {
    padding-left: 0.5rem;
    padding-top: 0.4rem;
    color: #FF0000;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/project/add.vue